<h1 class="auth-title">Recupera tu contraseña</h1>
<p class="auth-lead">Escribe el correo de tu cuenta y te enviaremos un enlace para crear una nueva.</p>

<form class="form-start" [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()" novalidate>
  <div class="fields">
    <div>
      <label class="field-label" for="forgot-email">Correo electrónico</label>
      <input type="email" id="forgot-email" class="input" formControlName="email" autocomplete="email"
        inputmode="email" placeholder="nombre@correo.com"
        [class.is-invalid]="emailControl.invalid && (emailControl.dirty || emailControl.touched)"
        [attr.aria-invalid]="emailControl.invalid && (emailControl.dirty || emailControl.touched)"
        [attr.aria-describedby]="emailControl.invalid && (emailControl.dirty || emailControl.touched) ? 'forgot-email-error' : null" />
      @if (emailControl.invalid && (emailControl.dirty || emailControl.touched)) {
      <p class="field-error" id="forgot-email-error">
        {{ emailControl.hasError('required') ? 'Escribe tu correo.' : 'Revisa el correo, debe verse como nombre@correo.com.' }}
      </p>
      }
    </div>
  </div>

  <div class="actions">
    <button type="submit" class="btn-primary" [disabled]="isSubmitting || forgotPasswordForm.invalid">
      @if (isSubmitting) {
      <span class="spinner" aria-hidden="true"></span>
      Enviando enlace…
      } @else {
      Enviar enlace
      }
    </button>
  </div>
</form>

<p class="switch-line">
  ¿Ya la recordaste?
  <a routerLink="/auth/signin" class="link">Vuelve a iniciar sesión</a>
</p>
